export const getServiceIcon = (urlBase: string, serviceCode: string) => {

  try {
    if (serviceCode) {
      return urlBase + `service_${serviceCode}.svg`;
    } else {
      return urlBase + "service_default.svg"
    }
  } catch (err) {
    return urlBase + "service_default.svg";
  }
};